import React from "react";
import "../../assets/css/services.css";
import { motion } from "framer-motion";

export default function Services() {

  const services = [
    { title: "Group Tours & Family Trips", icon: "👨‍👩‍👧‍👦" },
    { title: "Corporate Event Management", icon: "🏢" },
    { title: "Hotel Booking & Stay", icon: "🏨" },
    { title: "Flight & Transport", icon: "✈️" },
    { title: "Custom Travel Packages", icon: "🎒" },
    { title: "Religious Tours", icon: "🛕" },
    { title: "Adventure Trips", icon: "🏔️" }
  ];

  return (
    <section className="services">

      {/* Floating Background */}
      <div className="service-bg one"></div>
      <div className="service-bg two"></div>

      <div className="service-container">

        {/* 🔥 UNIQUE HEADER */}
        <motion.div
          className="service-header"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
        >
          <h2>
            Our <span>Services</span>
          </h2>
          <p>Crafting journeys with passion & precision ✨</p>
        </motion.div>

        {/* Cards */}
        <div className="service-grid">
          {services.map((item, i) => (
            <motion.div
              className="service-card"
              key={i}
              whileHover={{ rotateX: 5, rotateY: -5 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <div className="card-inner">

                <div className="icon">{item.icon}</div>

                <h3>{item.title}</h3>

                <div className="card-border"></div>

              </div>
            </motion.div>
          ))}
        </div>

      </div>

    </section>
  );
}